/**
 * @generated SignedSource<<63d29fc2e4b7b13b5431ad6d77aafb97>>
 * @relayHash e631e61cba47acbda6811ed1a287d9f5
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 620b7134d06fa893e7db6526963c4d8afbe3dc9c5b0428d93f35a2c73fa2ea86

import type { ConcreteRequest, Query } from 'relay-runtime';
export type fetchAppRecommendationsV2Query$variables = {
  cloudId: string;
};
export type fetchAppRecommendationsV2Query$data = {
  readonly growthRecommendations: {
    readonly recommendations: {
      readonly data?: ReadonlyArray<{
        readonly entityId?: string;
      }> | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type fetchAppRecommendationsV2Query = {
  response: fetchAppRecommendationsV2Query$data;
  variables: fetchAppRecommendationsV2Query$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  }
],
v1 = [
  {
    "fields": [
      {
        "kind": "Literal",
        "name": "product",
        "value": "jira"
      },
      {
        "kind": "Variable",
        "name": "tenantId",
        "variableName": "cloudId"
      },
      {
        "kind": "Literal",
        "name": "useCase",
        "value": "jiraProjectMenuRecommendations"
      }
    ],
    "kind": "ObjectValue",
    "name": "context"
  },
  {
    "kind": "Literal",
    "name": "first",
    "value": 2
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "entityId"
},
v3 = {
  "kind": "ScalarField",
  "name": "__typename"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "fetchAppRecommendationsV2Query",
    "selections": [
      {
        "concreteType": "GrowthRecQuery",
        "kind": "LinkedField",
        "name": "growthRecommendations",
        "plural": false,
        "selections": [
          {
            "args": (v1/*: any*/),
            "kind": "LinkedField",
            "name": "recommendations",
            "plural": false,
            "selections": [
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "data",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "kind": "RequiredField",
                            "field": (v2/*: any*/),
                            "action": "THROW",
                            "path": "growthRecommendations.recommendations.data.entityId"
                          }
                        ],
                        "type": "GrowthRecJiraTemplateRecommendation"
                      }
                    ]
                  }
                ],
                "type": "GrowthRecRecommendations"
              }
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "fetchAppRecommendationsV2Query",
    "selections": [
      {
        "concreteType": "GrowthRecQuery",
        "kind": "LinkedField",
        "name": "growthRecommendations",
        "plural": false,
        "selections": [
          {
            "args": (v1/*: any*/),
            "kind": "LinkedField",
            "name": "recommendations",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "data",
                    "plural": true,
                    "selections": [
                      (v3/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v2/*: any*/)
                        ],
                        "type": "GrowthRecJiraTemplateRecommendation"
                      }
                    ]
                  }
                ],
                "type": "GrowthRecRecommendations"
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "620b7134d06fa893e7db6526963c4d8afbe3dc9c5b0428d93f35a2c73fa2ea86",
    "metadata": {},
    "name": "fetchAppRecommendationsV2Query",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "eaaab66d3f41b01ce8e8a969a422ff60";

export default node;
